"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "25 8.99 23.5 8.99 23.5 1.5 1.5 1.5 1.5 8.99 0 8.99 0 0 25 0 25 8.99",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "25 25 0 25 0 16.01 1.5 16.01 1.5 23.5 23.5 23.5 23.5 16.01 25 16.01 25 25",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,10a.5.5,0,0,1-.5-.5V6.1a.5.5,0,0,1,1,0V9.47A.5.5,0,0,1,12.5,10Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,19.4a.5.5,0,0,1-.5-.5V15.53a.5.5,0,0,1,1,0V18.9A.5.5,0,0,1,12.5,19.4Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.08,13H15.53a.5.5,0,0,1,0-1h8.56a.5.5,0,1,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.47,13H1.13a.5.5,0,0,1,0-1H9.47a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "1.14",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.41,16.94A.5.5,0,0,1,4,16.77l-3.6-4a.5.5,0,0,1,0-.67L4,8.22a.5.5,0,0,1,.73.68L1.48,12.45,4.78,16.1a.5.5,0,0,1-.37.83Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.59,16.94a.5.5,0,0,1-.37-.83l3.29-3.65L20.23,8.9A.5.5,0,0,1,21,8.22l3.6,3.89a.5.5,0,0,1,0,.67l-3.6,4A.5.5,0,0,1,20.59,16.94Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;